export default __webpack_public_path__ + "static/media/progressTracker.15671807.jpg";